import React, { useState } from 'react';
import { useCart } from '../context/CartContext';

const ProductCard = ({ product }) => {
  const { items, addToCart, updateQuantity } = useCart();
  const [selectedWeight, setSelectedWeight] = useState(
    product.priceWeightList?.[0]?.weight || ''
  );

  const getPriceData = () => {
    if (!product.priceWeightList || product.priceWeightList.length === 0) {
      return null;
    }
    return (
      product.priceWeightList.find(p => p.weight === selectedWeight) ||
      product.priceWeightList[0]
    );
  };

  const priceData = getPriceData();

  const getCartQuantity = () => {
    if (!priceData) return 0;
    const item = items.find(
      i => i.productId === product._id && i.weight === priceData.weight
    );
    return item ? item.quantity : 0;
  };

  const cartQty = getCartQuantity();

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
      <div className="relative">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-auto object-contain aspect-square"
          loading="lazy"
        />
        {product.comingSoon && (
          <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
            <span className="text-white bg-[#8e0707] px-4 py-2 rounded">
              Coming Soon
            </span>
          </div>
        )}
      </div>

      <div className="p-6">
        <h3 className="text-xl font-bold text-[#272727] mb-1">
          {product.name}
        </h3>

        <p className="text-[#272727]/70 mb-4">{product.description}</p>

        {product.inStock && (
          <div className="mb-3">
            <label className="block text-sm text-[#272727]/70 mb-1">
              Size
            </label>
            <select
              value={selectedWeight}
              onChange={e => setSelectedWeight(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded"
            >
              {product.priceWeightList.map(p => (
                <option key={p._id} value={p.weight}>
                  {p.weight}
                </option>
              ))}
            </select>
          </div>
        )}

        {priceData && (
          <div className="product-price">
            <span className="current-price">₹{priceData.price}</span>
            {priceData.originalPrice && (
              <span className="original-price">
                ₹{priceData.originalPrice}
              </span>
            )}
          </div>
        )}

        {product.inStock && !product.comingSoon && (
          cartQty > 0 ? (
            <div className="flex items-center gap-2">
              <button
                onClick={() =>
                  updateQuantity(product._id, priceData.weight, cartQty - 1)
                }
                className="w-8 h-8 bg-[#8e0707] text-white rounded-full"
              >
                -
              </button>
              <span className="w-8 text-center font-bold">{cartQty}</span>
              <button
                onClick={() =>
                  updateQuantity(product._id, priceData.weight, cartQty + 1)
                }
                className="w-8 h-8 bg-[#8e0707] text-white rounded-full"
              >
                +
              </button>
            </div>
          ) : (
            <button
              onClick={() => {
                if (!priceData) return;
                addToCart(product, priceData);
              }}
              className="bg-[#8e0707] hover:bg-[#6b0505] text-white px-4 py-2 rounded"
            >
              Add
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default React.memo(ProductCard);